<template>
  <button
    :class="{
      'light': variant === 'light',
      'primary': variant === 'primary',
      'secondary': variant === 'secondary',
      'disabled': disabled
    }"
    :type="type"
    @click="onClickButton"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'StellaButton',
  props: {
    variant: {
      type: String,
      default: 'light'
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    to: Object
  },
  methods: {
    onClickButton: function() {
      if (!this.to) return
      this.$router.push(this.to)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

button {
  display: inline-block;
  text-align: center;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.25rem 1.5rem;
  border-radius: 0.25rem;
  outline: none;

  &.primary {
    color: white;
    background-color: $primary-color;
  }

  &.secondary {
    color: white;
    background-color: $secondary-color;
  }

  &.light {
    color: black;
    background-color: white;
    border: 1px solid white;
  }

  &.disabled {
    opacity: .65;
  }
}
</style>
